import React from 'react';
import { Menu, Dropdown, Label, Icon } from 'semantic-ui-react';

function groupIntoDecades(buckets) {
  const grouped = {};

  buckets.forEach(b => {
    const year = new Date(b.key_as_string || b.key).getUTCFullYear();
    if (isNaN(year)) return; // skip invalid
    const decade = Math.floor(year / 10) * 10; // e.g. 1941 → 1940
    if (!grouped[decade]) {
      grouped[decade] = 0;
    }
    grouped[decade] += b.doc_count;
  });

  return Object.entries(grouped).map(([decade, count]) => ({
    label: `${decade}s`,
    doc_count: count
  }));
}

export const Filters = ({aggs, aliases}) => {
  const terms = {};

  if (!aggs) {
    return (<React.Fragment></React.Fragment>);
  }



  const items = Object.keys(aggs).map(k => {
    let name = k.replace(/\W+|_+/ig, ' ').trim();
    terms[name] = aggs[k];
    return name;
  }).sort().map((name, i) => {
      let buckets = terms[name].buckets;

      
      if (buckets.length && !isNaN(Date.parse(buckets[0].key_as_string))) {
        buckets = groupIntoDecades(buckets); // converting yearly buckets into decades from date_histogram fields
      }

      // Replaces buckets with names 0s with Unknown
      buckets = buckets.map(b => {
        if ((b.label && b.label === "0s") || (b.key_as_string && b.key_as_string.startsWith("0"))) {
          return { ...b, label: "Unknown" };
        }
        return b;
      });
      
      buckets = buckets.filter(b => b.doc_count > 0); //No buckets with count 0 will be displayed

      const list = buckets.map((b, i) => (

        <Dropdown.Item key={i}>
          {b.label || b.key_as_string || b.key}
          <Label horizontal basic color='grey' size='mini'>
            <Icon name='file' />
            {b.doc_count}
          </Label>
        </Dropdown.Item>
      ));
      
    return (
      <Dropdown item text={name} key={i}>
        <Dropdown.Menu>
          {list}
        </Dropdown.Menu>
      </Dropdown>
    );
  });

  return (
    <React.Fragment>
      <Menu vertical secondary fluid>
        <Menu.Item header>Filters</Menu.Item>
        {items}
      </Menu>
    </React.Fragment>
  );
};